import type { RouteObject } from 'react-router-dom'

import { MainLayout } from '@/components/layout/MainLayout'
import Home from '@/pages/home/HomePage'

export const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
    ],
  },
]
